import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FpassuiComponent } from './forgot-password-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { DirectivesModule } from '../../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/index";

@NgModule({
  declarations: [FpassuiComponent],
  imports: [
    CommonModule, AngularMaterialModule,
    FormsModule, ReactiveFormsModule, PipesModule, DirectivesModule
  ],
  exports:[FpassuiComponent]
})
export class FpassuiModule { }
